<template >
<div >
    <v-layout v-if="!page_show">
        <not-page-spinner :not_show="true" /> 
    </v-layout>  
    <v-container v-else grid-list-l> 
        <v-row> 
            <!-- //LEFT SIDE -->
            <v-col sm="9" cols="12"> 
                <v-layout column>
                    <v-layout row wrap>
                        <v-sheet 
                            color=""
                            class="mx-auto py-1 pb-5"
                            elevation="2"
                            width="100%">
                            <v-layout al>
                                <div class="not-f7 font-weight-bold pa-5 primary--text">Our Communities</div>
                                <v-spacer></v-spacer>
                                <div class="pa-5">
                                    <v-text-field  color="primary" v-model="nameSearch1"
                                        background-color="primary lighten-4" 
                                        placeholder="Type comminity's name"
                                        id="search1"
                                        rounded=""  dense=""
                                        outlined="" 
                                        label="Search Community"
                                        append-icon="search"
                                    ></v-text-field> 
                                </div> 
                            </v-layout>
                            <hr>
                            <br>
                            <div class="px-5 font-italic">Total number of communities: {{communities.length}}</div>
                            <v-row class="px-5">
                                <v-col sm="6" v-for="(community, index) in communities?p_communities.list:null"
                                        :key="index">
                                    <v-card 
                                        :to="'communities/'+community.name" flat="" 
                                        color="primary"  
                                        width="" hover=""  class="mx-1" outlined="">
                                        <v-hover v-slot:default="{hover}">
                                            <v-list>
                                              <v-list-item >
                                                  <v-list-item-action>
                                                      <v-icon>group</v-icon>
                                                  </v-list-item-action>
                                                  <v-list-item-content>
                                                      <v-list-item-title>{{community.name}}</v-list-item-title>
                                                      <v-list-item-subtitle>{{0}} sister(s)</v-list-item-subtitle> 
                                                  </v-list-item-content> 
                                              </v-list-item>  
                                            </v-list> 
                                        </v-hover> 
                                    </v-card> 
                                </v-col>
                            </v-row> 
                            <v-layout justify-center="" class="my-3" v-if="communities">
                                <v-pagination
                                    v-model="page_current"
                                    class="mt-4"
                                    :length="p_communities?p_communities.pages:0"/> 
                            </v-layout>
                        </v-sheet> 
                    </v-layout>

                    
                    
                </v-layout>
            </v-col>


            <!-- //RIGHT SIDE -->
            <v-col sm="3">
                <v-layout column="">  
                    <v-card class="">
                        <v-card-title class="primary white--text">
                            SISTERS
                        </v-card-title>
                        <v-card-text>
                            <v-list single-line dense="" color="b2m">
                                <div color="b2" v-for="(item, index) in not.ARRAY_F(JOINED_sisters,10)" :key="index">
                                    <v-list-item :to="'/about/sisters/'+item.key">{{item.first_name}} {{item.surname}}</v-list-item>
                                    <v-divider></v-divider>
                                </div> 
                            </v-list>
                            <v-layout row wrap justify-center="">
                                <v-btn :to="'/about/sisters/'" outlined="" color="primary">View All</v-btn>
                            </v-layout>
                        </v-card-text> 
                    </v-card>
                     
                </v-layout>
            </v-col>
        </v-row>
       
        
    </v-container>
   
</div>
</template>

<script>
    let pageName = "Ministry"
    export default{
        props:["id","not"],
        name: pageName,  
        data: () => ({
            page_show: false,   
            page_current:1,
            page_size:12,
            nameSearch:'',
            nameSearch1:'',
            images:[
                {src:'/images/teresian/t26.JPG',local:true},
            ],
           
        }),
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notImages:this.images,
                notText:false,
                notIndicators:true,
                notHeight:350
            })
            this.pageLoad(500)
        },
        //---------computed-----------
        computed: { 
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            congregations(){
                return this.$store.getters.getCongregation
            }, 
            sisters(){
                let sisters = this.$store.getters.getSisters

                //Search through  sisters
                return sisters.filter(ss=>{
                    let name = this.not.TEXT_UP(ss.first_name)+" "+this.not.TEXT_UP(ss.surname)
                    let nameSearch = this.not.TEXT_UP(this.nameSearch)
                    let index = 1
                    if (nameSearch) {
                        index = name.indexOf(nameSearch)
                    }
                    return index != -1
                })
            }, 
            p_sisters(){
                if (!this.JOINED_sisters) {
                    return null
                }
                let list = [...this.JOINED_sisters]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            },
            p_communities(){
                if (!this.communities) {
                    return null
                }
                let list = [...this.communities]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            },
            positions(){
                let sisters = this.sisters
                if(!sisters){return null}
                let positions = []
                sisters.forEach(element => {
                    let pos = element.position
                    let index = positions.indexOf(pos)
                    if (index ===-1) {
                        positions.push(pos)
                    }
                });
                return positions
            },
            stuff_sisters(){
                let sisters = this.JOINED_sisters
                if(!sisters){return null} 
                let siss = sisters.filter(sis=>{
                    return sis.staff =='yes'
                })
                return siss
            },
            JOINED_sisters(){
                let sisters = this.sisters 
                let joinSisters = this.not.JOIN_SISTERS(sisters)
                return joinSisters
            },
            communities(){
                let sisters = this.sisters 
                let communities = this.not.JOIN_COMMUNITIES(sisters) 

                //Search through  sisters
                return communities.filter(mm=>{
                    let name = this.not.TEXT_UP(mm.name) 
                    let nameSearch = this.not.TEXT_UP(this.nameSearch1)
                    let index = 1
                    if (nameSearch) {
                        index = name.indexOf(nameSearch)
                    }
                    return index != -1
                })
            },
        },

        //--------methods-----------
        methods:{
             
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //CHECK USER STATE
                    if (ps.indexOf('logging')!==-1) { 
                        this.page_show = false
                    } else {   
                        this.page_show = true
                    } 

                    //Check proccess 
                    if (ps.indexOf('add/bibleStudy')!==-1) {
                        this.not.notDialogP(true,true,'adding...') 
                    }else{
                        this.not.notDialogP(false) 
                    }  

                    if (ps.indexOf('delete/bibleStudy')!==-1) {
                        this.not.notDialogP(true,true,'delete...') 
                    }else{
                        this.not.notDialogP(false) 
                    } 

                    //check response
                    if (res.res==='add/bibleStudy/successful') { 
                        this.not.notDialog(true,true,'Successful','Bible study, successfuly added.','','OK',{code:2}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='add/bibleStudy/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding bible study.','Cancel','Try again',{code:3}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }

                    if (res.res==='delete/bibleStudy/successful') { 
                        this.not.notDialog(true,true,'Successful','Bible study, successfuly deleted.','','OK',{code:5})
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='delete/bibleStudy/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting bible study.','Cancel','Try again',{code:5}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                },t)
            }
        }, 
        watch: {
            us(v){
                 
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>

 